import {ReactNode} from "react";
import {Group, SidebarItem, WorkspaceMember} from "../types";

export function addCommaSeparator(currentItemIndex: number, allItems: any[]) {
  return currentItemIndex < allItems.length - 2 ? ", " : "";
}

// Property 'ListFormat' does not exist on type 'typeof Intl'.
// @ts-ignore The type is missing on our current version but it works as expected
export const listFormatter = new Intl.ListFormat("en", {
  style: "long",
  type: "conjunction",
});

export const removeAccents = (str: string) =>
  str.normalize("NFD").replace(/\p{Diacritic}/gu, "");

export const truncate = (str: string, length: number, ellipsis="...") => {
  if (str.length <= length) {
    return str;
  }
  return str.substring(0, length) + ellipsis;
}

export const formatName = (name: string): string => {
  const names = name
    .replace(/[\[\(\)\]\_\-\#\@\.\,]/gi, "")
    .split(" ")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))

  const lastName = names.length > 0 ? names[names.length - 1] : "";
  return names[0] + (lastName ? ` ${lastName.charAt(0)}.` : "");
}
